export default {
  common: {
    unexpected: 'An unexpected error occurred',
    tryAgain: 'Please try again later',
    refresh: 'Refresh page'
  },
  network: {
    offline: 'You appear to be offline',
    connectionLost: 'Connection lost',
    serverError: 'Server error',
    requestFailed: 'Request failed'
  },
  game: {
    loadFailed: 'Failed to load game',
    unsupported: 'Your browser may not support this game',
    missingDependencies: 'Missing components required to run the game'
  },
  validation: {
    required: 'This field is required',
    email: 'Please enter a valid email address',
    minLength: 'Please enter at least {min} characters',
    maxLength: 'Cannot exceed {max} characters'
  }
}; 